import type {
  DynamicPageList,
  DynamicPageType,
  LoadDynamicPageType,
} from '../../Types/Api/DynamicPage'
import type { OKRes } from '../../Types/Api/Ok'
import { api } from './API'
import { requireAuth } from './Auth'

export const fetchDynamicPages = async (name: string) => {
  return await requireAuth<DynamicPageList[]>(
    api.get(`pages/dynamic?site_name=${name}`),
  )
}

export const loadDynamicPage = async (id: number, name: string) => {
  return await requireAuth<LoadDynamicPageType>(
    api.get(`pages/dynamic/${id}`, { site_name: name }),
  )
}

export const updateDynamicPage = async (
  id: number,
  name: string,
  requestValues: DynamicPageType,
) => {
  return await requireAuth<OKRes>(
    api.patch(`pages/dynamic/${id}`, { site_name: name, ...requestValues }),
  )
}
